import { styled } from '@mui/material/styles';

import { SharedContainerStepsStyles } from '../../shared/styles/sharedBookingStyles';

export const StyledContainer = styled('section')(
  ({ theme }) => `
 ${SharedContainerStepsStyles({ theme })}
`,
);

export const StyledCheckIcon = styled('div')(
  ({ theme }) => `
   svg {
    width: 100%;
    height: 100%;
    max-width: 50px;
    fill: none;
     > rect:last-of-type {
        stroke: ${theme.DS_palette.state.success};
     }
   }
   
`,
);

export const StyledSuccessLogin = styled('div')(
  ({ theme }) => `
  display: flex;

 
  h3 {
   padding-top: ${theme.DS_spacing(['xxxs'])}
  }
   
`,
);

export const StyledDS_ButtonLink = styled('div')(
  () => `
  button {
   &:hover {
   box-shadow: none;
   }
  }
 
   
`,
);
